import { useEffect, useState, useRef } from "react";

export default function ActWorkook202601Page() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    audioRef.current = new Audio("https://dynavision.co.jp/data/180823-02.mp3");
    audioRef.current.addEventListener("ended", () => setIsPlaying(false));
    return () => {
      audioRef.current?.pause();
      audioRef.current = null;
    };
  }, []);

  const toggleAudio = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  useEffect(() => {
    createStars("stars", 80);
    createStars("stars2", 50);
  }, []);

  function createStars(containerId: string, count: number) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const star = document.createElement("div");
      star.className = "workbook-star";
      const size = Math.random() * 2 + 0.5;
      star.style.cssText = `
        width: ${size}px;
        height: ${size}px;
        left: ${Math.random() * 100}%;
        top: ${Math.random() * 100}%;
        animation-delay: ${Math.random() * 4}s;
        animation-duration: ${2 + Math.random() * 3}s;
      `;
      container.appendChild(star);
    }
  }

  return (
    <>
      <style>{`
        .wb-body {
          font-family: 'Noto Sans JP', 'Hiragino Kaku Gothic ProN', sans-serif;
          background: #f7f4ef;
          color: #2a2318;
          font-size: 14px;
          line-height: 1.9;
          -webkit-font-smoothing: antialiased;
        }
        @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@300;400;600&family=Noto+Sans+JP:wght@300;400;500&family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&display=swap');

        .wb-nav {
          position: sticky;
          top: 0;
          z-index: 100;
          background: rgba(247,244,239,0.97);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(180,145,80,0.25);
          padding: 12px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .wb-nav-title {
          font-family: 'Cormorant Garamond', 'Noto Serif JP', serif;
          font-size: 13px;
          letter-spacing: 0.15em;
          color: #7a5c2a;
        }
        .wb-print-btn {
          background: #c9a96e;
          color: #1a1a2e;
          border: none;
          padding: 7px 16px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          font-family: 'Noto Sans JP', sans-serif;
          letter-spacing: 0.05em;
          transition: opacity 0.2s;
        }
        .wb-print-btn:hover { opacity: 0.85; }

        .wb-cover {
          min-height: 100vh;
          background: linear-gradient(160deg, #f0ebe0 0%, #e8e0f0 40%, #e0ede0 100%);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 24px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .wb-cover::before {
          content: '';
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 60% 40% at 70% 30%, rgba(201,169,110,0.15) 0%, transparent 60%),
            radial-gradient(ellipse 40% 60% at 20% 70%, rgba(123,111,160,0.1) 0%, transparent 60%),
            radial-gradient(ellipse 50% 30% at 50% 90%, rgba(200,220,200,0.3) 0%, transparent 60%);
          pointer-events: none;
        }
        .wb-stars {
          position: absolute;
          inset: 0;
          pointer-events: none;
          overflow: hidden;
        }
        .workbook-star {
          position: absolute;
          background: rgba(180,150,80,0.4);
          border-radius: 50%;
          animation: wb-twinkle 3s ease-in-out infinite;
        }
        @keyframes wb-twinkle {
          0%, 100% { opacity: 0.2; }
          50% { opacity: 0.7; }
        }
        .wb-cover-ornament {
          font-family: 'Cormorant Garamond', serif;
          font-size: 11px;
          letter-spacing: 0.4em;
          color: #8a6a2e;
          margin-bottom: 32px;
          position: relative;
        }
        .wb-cover-ornament::before,
        .wb-cover-ornament::after {
          content: '──────';
          color: rgba(180,145,80,0.5);
          font-size: 8px;
          vertical-align: middle;
          margin: 0 12px;
        }
        .wb-cover h1 {
          font-family: 'Noto Serif JP', serif;
          font-weight: 300;
          font-size: clamp(22px, 6vw, 36px);
          line-height: 1.8;
          color: #2a2318;
          margin-bottom: 20px;
          position: relative;
        }
        .wb-cover h1 em {
          font-style: normal;
          color: #7a5c2a;
          font-weight: 400;
        }
        .wb-cover-sub {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(13px, 3vw, 17px);
          font-style: italic;
          color: rgba(60,45,20,0.6);
          letter-spacing: 0.08em;
          margin-bottom: 40px;
        }

        .wb-how-page {
          background: #f7f4ef;
          padding: 60px 24px;
          max-width: 760px;
          margin: 0 auto;
        }
        .wb-page-label {
          font-size: 10px;
          letter-spacing: 0.3em;
          color: #8a6a2e;
          margin-bottom: 12px;
          font-family: 'Cormorant Garamond', serif;
        }
        .wb-page-title {
          font-family: 'Noto Serif JP', serif;
          font-weight: 300;
          font-size: clamp(18px, 4vw, 26px);
          color: #2a2318;
          margin-bottom: 32px;
          line-height: 1.7;
        }
        .wb-how-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 16px;
          margin-bottom: 32px;
        }
        .wb-how-card {
          background: rgba(255,255,255,0.7);
          border: 1px solid rgba(180,145,80,0.25);
          border-radius: 12px;
          padding: 20px;
        }
        .wb-how-card-num {
          font-family: 'Cormorant Garamond', serif;
          font-size: 28px;
          color: #c9a96e;
          line-height: 1;
          margin-bottom: 8px;
          opacity: 0.8;
        }
        .wb-how-card-title {
          font-size: 14px;
          font-weight: 500;
          color: #5a3e10;
          margin-bottom: 6px;
        }
        .wb-how-card-desc {
          font-size: 12px;
          color: rgba(42,35,24,0.65);
          line-height: 1.8;
        }
        .wb-sites-flow {
          display: flex;
          align-items: center;
          background: rgba(255,255,255,0.6);
          border: 1px solid rgba(180,145,80,0.2);
          border-radius: 12px;
          padding: 20px;
          flex-wrap: wrap;
          gap: 8px;
          justify-content: center;
        }
        .wb-flow-site { text-align: center; padding: 12px 16px; }
        .wb-flow-site-name {
          font-family: 'Noto Serif JP', serif;
          font-size: 13px;
          color: #2a2318;
          margin-bottom: 4px;
        }
        .wb-flow-badge {
          display: inline-block;
          background: #c9a96e;
          color: #fff;
          font-size: 10px;
          padding: 2px 10px;
          border-radius: 10px;
          letter-spacing: 0.1em;
          font-weight: 500;
        }
        .wb-flow-arrow {
          color: rgba(180,145,80,0.5);
          font-size: 18px;
          padding: 0 4px;
        }

        .wb-section-divider {
          text-align: center;
          padding: 40px 0 20px;
          color: rgba(180,145,80,0.5);
          font-size: 12px;
          letter-spacing: 0.3em;
          font-family: 'Cormorant Garamond', serif;
        }

        .wb-day-page {
          max-width: 760px;
          margin: 0 auto;
          padding: 48px 24px 64px;
          border-top: 1px solid rgba(180,145,80,0.15);
        }
        .wb-day-header {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          margin-bottom: 32px;
          padding-bottom: 24px;
          border-bottom: 1px solid rgba(180,145,80,0.25);
        }
        .wb-day-circle {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          border: 1px solid #c9a96e;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: rgba(201,169,110,0.08);
        }
        .wb-day-circle-label {
          font-size: 8px;
          letter-spacing: 0.15em;
          color: #8a6a2e;
          font-family: 'Cormorant Garamond', serif;
        }
        .wb-day-circle-num {
          font-family: 'Cormorant Garamond', serif;
          font-size: 22px;
          color: #7a5c2a;
          line-height: 1;
        }
        .wb-day-title {
          font-family: 'Noto Serif JP', serif;
          font-weight: 400;
          font-size: clamp(16px, 4vw, 22px);
          color: #2a2318;
          line-height: 1.5;
          margin-bottom: 4px;
        }
        .wb-day-subtitle {
          font-size: 12px;
          color: rgba(42,35,24,0.5);
          font-style: italic;
          font-family: 'Cormorant Garamond', serif;
        }

        .wb-intention-box {
          background: rgba(201,169,110,0.08);
          border: 1px solid rgba(201,169,110,0.3);
          border-radius: 10px;
          padding: 18px 20px;
          margin-bottom: 28px;
        }
        .wb-intention-label {
          font-size: 10px;
          letter-spacing: 0.25em;
          color: #8a6a2e;
          margin-bottom: 8px;
        }
        .wb-intention-text {
          font-size: 13px;
          color: rgba(42,35,24,0.8);
          line-height: 1.9;
          font-family: 'Noto Serif JP', serif;
          font-weight: 300;
        }

        .wb-question-block { margin-bottom: 28px; }
        .wb-question-label {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 14px;
        }
        .wb-q-num {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: rgba(201,169,110,0.15);
          border: 1px solid #c9a96e;
          color: #8a6a2e;
          font-size: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-family: 'Cormorant Garamond', serif;
        }
        .wb-q-text {
          font-size: 14px;
          color: rgba(42,35,24,0.9);
          line-height: 1.7;
          font-family: 'Noto Serif JP', serif;
          font-weight: 300;
        }
        .wb-write-lines { padding: 4px 0; }
        .wb-write-line {
          height: 36px;
          border-bottom: 1px solid rgba(180,145,80,0.3);
          width: 100%;
        }

        .wb-mini-work {
          background: rgba(200,230,200,0.25);
          border: 1px solid rgba(100,160,100,0.3);
          border-left: 3px solid rgba(80,160,80,0.6);
          border-radius: 0 10px 10px 0;
          padding: 18px 20px;
          margin-bottom: 28px;
        }
        .wb-mini-work-label {
          font-size: 10px;
          letter-spacing: 0.2em;
          color: rgba(40,120,40,0.8);
          margin-bottom: 8px;
        }
        .wb-mini-work-content {
          font-size: 13px;
          color: rgba(42,35,24,0.75);
          line-height: 1.9;
        }
        .wb-mini-work-steps {
          list-style: none;
          padding: 0;
          margin-top: 10px;
        }
        .wb-mini-work-steps li {
          padding: 3px 0 3px 18px;
          position: relative;
          font-size: 13px;
          color: rgba(42,35,24,0.7);
        }
        .wb-mini-work-steps li::before {
          content: '▸';
          position: absolute;
          left: 0;
          color: rgba(80,160,80,0.7);
          font-size: 10px;
          top: 5px;
        }

        .wb-declaration {
          background: rgba(201,169,110,0.08);
          border: 1px solid rgba(201,169,110,0.35);
          border-radius: 10px;
          padding: 20px 24px;
          text-align: center;
          margin-bottom: 28px;
          position: relative;
          overflow: hidden;
        }
        .wb-declaration::before {
          content: '✦';
          position: absolute;
          top: 10px;
          left: 16px;
          color: rgba(201,169,110,0.3);
          font-size: 20px;
        }
        .wb-declaration::after {
          content: '✦';
          position: absolute;
          bottom: 10px;
          right: 16px;
          color: rgba(201,169,110,0.3);
          font-size: 20px;
        }
        .wb-declaration-label {
          font-size: 10px;
          letter-spacing: 0.25em;
          color: #8a6a2e;
          margin-bottom: 12px;
        }
        .wb-declaration-text {
          font-family: 'Noto Serif JP', serif;
          font-weight: 400;
          font-size: clamp(13px, 3vw, 16px);
          color: #4a3010;
          line-height: 2;
        }

        .wb-water-reminder {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 16px;
          background: rgba(180,210,240,0.2);
          border: 1px solid rgba(100,150,200,0.25);
          border-radius: 8px;
          margin-bottom: 20px;
        }
        .wb-water-icon { font-size: 16px; }
        .wb-water-text {
          font-size: 11px;
          color: rgba(42,35,24,0.55);
          letter-spacing: 0.05em;
        }

        .wb-complete-row {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 8px;
          padding-top: 12px;
          border-top: 1px solid rgba(42,35,24,0.08);
        }
        .wb-check-box {
          width: 18px;
          height: 18px;
          border: 1px solid rgba(180,145,80,0.5);
          border-radius: 4px;
          display: inline-block;
        }
        .wb-complete-label {
          font-size: 11px;
          color: rgba(138,106,46,0.6);
          letter-spacing: 0.15em;
        }

        .wb-closing-page {
          min-height: 60vh;
          background: linear-gradient(160deg, #f0ebe0 0%, #e8e0f0 50%, #e0ede0 100%);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 80px 24px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .wb-closing-message {
          font-family: 'Noto Serif JP', serif;
          font-weight: 300;
          font-size: clamp(14px, 3.5vw, 18px);
          line-height: 2.4;
          color: rgba(42,35,24,0.85);
          max-width: 500px;
          margin-bottom: 32px;
        }
        .wb-closing-sig {
          font-family: 'Cormorant Garamond', serif;
          font-size: 16px;
          font-style: italic;
          color: #7a5c2a;
          letter-spacing: 0.1em;
        }

        @media print {
          @page { size: A4; margin: 15mm 18mm 18mm; }
          * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .wb-body { background: #fff !important; color: #1a1a2e !important; font-size: 10pt; }
          .wb-nav { display: none !important; }
          .wb-cover {
            min-height: auto;
            page-break-after: always;
            background: #f0ebe0 !important;
            padding: 60mm 30mm;
          }
          .wb-cover::before { display: none; }
          .wb-stars { display: none; }
          .wb-cover h1 { font-size: 24pt; color: #2a2318 !important; }
          .wb-cover-sub { font-size: 13pt; }
          .wb-how-page { page-break-after: always; background: #f7f4ef !important; padding: 20mm 0; }
          .wb-section-divider { display: none; }
          .wb-day-page { page-break-before: always; padding: 12mm 0 16mm; border-top: none !important; max-width: 100%; }
          .wb-day-header { padding-bottom: 8mm; }
          .wb-day-circle { border-color: #c9a96e !important; background: rgba(201,169,110,0.08) !important; }
          .wb-day-circle-label, .wb-day-circle-num { color: #8a6a2e !important; }
          .wb-day-title { color: #1a1a2e !important; font-size: 16pt; }
          .wb-day-subtitle { color: #7a6b5a !important; }
          .wb-intention-box { background: #f9f6ee !important; border-color: #d4b87a !important; }
          .wb-intention-label { color: #8a6a2e !important; }
          .wb-intention-text { color: #3a3028 !important; }
          .wb-q-num { background: #f5edd8 !important; border-color: #c9a96e !important; color: #8a6a2e !important; }
          .wb-q-text { color: #1a1a2e !important; }
          .wb-write-line { height: 32px !important; border-bottom-color: #c8b89a !important; }
          .wb-mini-work { background: #f0f5f0 !important; border-color: #90c890 !important; border-left-color: #60a860 !important; }
          .wb-mini-work-label { color: #3a7a3a !important; }
          .wb-mini-work-content, .wb-mini-work-steps li { color: #2a3a2a !important; }
          .wb-mini-work-steps li::before { color: #60a860 !important; }
          .wb-declaration { background: #faf5e8 !important; border-color: #d4b87a !important; }
          .wb-declaration-label { color: #8a6a2e !important; }
          .wb-declaration-text { color: #5a4020 !important; }
          .wb-declaration::before, .wb-declaration::after { color: #d4b87a !important; }
          .wb-water-reminder { background: #f0f5fa !important; border-color: #90b4d0 !important; }
          .wb-water-text { color: #3a5a7a !important; }
          .wb-complete-row { border-top-color: #e0d4c0 !important; }
          .wb-check-box { border-color: #c9a96e !important; }
          .wb-complete-label { color: #8a6a2e !important; }
          .wb-how-card { background: #f5f0e8 !important; border-color: #d4b87a !important; }
          .wb-how-card-num { color: #8a6a2e !important; }
          .wb-how-card-title { color: #3a2a10 !important; }
          .wb-how-card-desc { color: #5a4a38 !important; }
          .wb-closing-page { background: #f0ebe0 !important; page-break-before: always; }
        }
      `}</style>

      <div className="wb-body">
        {/* NAV */}
        <nav className="wb-nav">
          <span className="wb-nav-title">南米３大聖地遠隔・参加特典</span>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <button
              onClick={toggleAudio}
              className="wb-print-btn"
              style={{ background: isPlaying ? "#a07840" : "#6aaa8a", display: "flex", alignItems: "center", gap: "6px" }}
            >
              {isPlaying ? (
                <>
                  <span style={{ fontSize: "14px" }}>⏸</span>
                  <span>音源停止</span>
                </>
              ) : (
                <>
                  <span style={{ fontSize: "14px" }}>▶</span>
                  <span>音源再生</span>
                </>
              )}
            </button>
            <button className="wb-print-btn" onClick={() => window.print()}>🖨 印刷する</button>
          </div>
        </nav>

        {/* COVER */}
        <div className="wb-cover">
          <div className="wb-stars" id="stars"></div>
          <p className="wb-cover-ornament">南米３大聖地遠隔・参加特典</p>
          <h1>
            <em>Sacred Shield &amp; Clear</em><br />
            10日間ワークブック
          </h1>
          <p className="wb-cover-sub">Cleanse · Protect · Center · Create</p>
        </div>

        {/* HOW TO USE */}
        <div className="wb-how-page">
          <p className="wb-page-label">BEFORE YOU BEGIN</p>
          <h2 className="wb-page-title">このワークブックの<br />使い方</h2>
          <div className="wb-how-grid">
            {[
              { num: "01", title: "リラックスして始める", desc: "深呼吸を1〜2回。水を一口飲んで、今日の意図を静かに設定してください。「頑張ろう」とせず、ただ受け取る気持ちで。" },
              { num: "02", title: "直感で書く", desc: "問いへの答えは「正しいもの」を探さなくて大丈夫。浮かんだことをそのまま書きましょう。消したり書き直したりせず、流れに任せて。" },
              { num: "03", title: "宣言は声に出して", desc: "できれば声に出して読み上げてください。声に乗せることで、エネルギーがより深く定着します。一人でいる時間に行うのがおすすめです。" },
              { num: "04", title: "水で締める", desc: "最後に水を一口飲んでください。エネルギーを身体に落とし込む、大切な儀式です。" },
              { num: "05", title: "できない日があっても大丈夫", desc: "連続でできなくても焦らないで。ペースを崩した日があっても、翌日からそのまま続けてください。" },
              { num: "06", title: "音源と合わせて使う", desc: "30分ワーク音源はゆったりした日にお聴きください。5〜7分ミニワークは毎日の隙間時間にご活用ください。" },
            ].map((c) => (
              <div className="wb-how-card" key={c.num}>
                <div className="wb-how-card-num">{c.num}</div>
                <div className="wb-how-card-title">{c.title}</div>
                <div className="wb-how-card-desc">{c.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* PHASE 1 */}
        <div className="wb-section-divider">✦ PHASE 1 — 浄化 ✦</div>

        {/* DAY 1 */}
        <DayPage
          day={1} phase="PHASE 1 · 浄化 · ウユニ塩湖"
          title="ウユニ塩湖のエネルギーと繋がる"
          subtitle="今の自分を、そのまま受け取ることから始めます"
          intention="今日は何も変えようとしなくていい。ただ、今の自分をあるがままに見つめてください。ウユニ塩湖の静寂が、あなたの内側を映す鏡になります。"
          questions={[
            { q: "今、あなたの心や身体の中で「重い」と感じているものは何ですか? 感情でも状況でも、思いつくままに書いてください。", lines: 5 },
            { q: "それらを手放した後の自分へ、一言メッセージを書いてください(未来の自分への言葉)。", lines: 3 },
          ]}
          miniWorkLabel="✧ MINI WORK"
          miniWorkContent="目を閉じ、広大なウユニ塩湖の上に立つ自分をイメージしてください。"
          miniWorkSteps={[
            "空が地面に映り込む、静かな白い世界に立っています",
            "深呼吸を3回。吐く息とともに「重さ」を白い湖面に手放すイメージで",
            "吸う息で、澄んだ空気と光を身体の中に迎え入れます",
            "これを3回繰り返し、静かに目を開けてください",
          ]}
          declaration={"私は今日、重さを手放す準備ができています。\nウユニ塩湖の光が、私の内側を静かに照らしています。\n私はあるがままの自分を受け取ります。"}
        />

        {/* DAY 2 */}
        <DayPage
          day={2} phase="PHASE 1 · 浄化 · ウユニ塩湖"
          title="手放すものに気づく"
          subtitle="重さの正体を言葉にして、光に渡す"
          intention="昨日より少しだけ深く。あなたが無意識に抱えてきたものを、優しく光の中に差し出してみましょう。"
          questions={[
            { q: "今のあなたが「もういいや」と感じていること、疲れていること、手放したいことを3つ書いてください。", lines: 5 },
            { q: "それらを手放した後の自分へ、一言メッセージを書いてください(未来の自分への言葉)。", lines: 3 },
          ]}
          miniWorkLabel="✧ MINI WORK — 光への委ね"
          miniWorkSteps={[
            "Q1に書いたものを一つずつゆっくり読み上げる",
            "読み上げるごとに「これを光に渡します」と心の中で言う",
            "ウユニ塩湖の白い光の中に、それが溶けていくイメージを持つ",
            "深呼吸1回で、それぞれを完了させる",
          ]}
          declaration={"私は手放すことを選びます。\nそれはすべて、私が次へ進むための美しい一歩です。\n白い光の中に、委ねます。"}
        />

        {/* DAY 3 */}
        <DayPage
          day={3} phase="PHASE 1 · 浄化 · ウユニ塩湖"
          title="浄化を深める・定着させる"
          subtitle="3日間の浄化を統合し、軽さを感じる"
          intention="3日間で浮かんできたものたちに、感謝してお別れをします。軽くなった自分を、身体で感じてください。"
          questions={[
            { q: "3日間で気づいたことや、感じた変化を自由に書いてください(小さなことでも)。", lines: 4 },
            { q: "今の自分の身体や心は、3日前と比べてどうですか?気になる言葉やキーワードを書いてみてください。", lines: 3 },
          ]}
          miniWorkLabel="✧ MINI WORK — 浄化の統合"
          miniWorkSteps={[
            "静かに目を閉じ、3日間のワークを思い出す",
            "「私はここまで来た」と心の中で認める",
            "ウユニ塩湖の白い大地に、深くお礼を言う",
            "身体の中心から光が広がるイメージで深呼吸を3回",
          ]}
          declaration={"私の内側は今、清らかに整っています。\nウユニ塩湖の光に感謝します。\n軽くなった私は、次のステップへ進みます。"}
        />

        {/* PHASE 2 */}
        <div className="wb-section-divider">✦ PHASE 2 — 保護 ✦</div>

        {/* DAY 4 */}
        <DayPage
          day={4} phase="PHASE 2 · 保護 · アラムムル湖"
          title="アラムムルの守りを受け取る"
          subtitle="自分の「境界線」を穏やかに設定する"
          intention="アラムムルの聖なる水は、あなたを守る「見えない盾」を与えてくれます。拒絶ではなく、優しい結界。愛のある境界線を今日から築きます。"
          questions={[
            { q: "最近、誰か(または何か)のエネルギーや言葉に疲れたり、影響を受けすぎたと感じることがありましたか?", lines: 4 },
            { q: "「自分を守る」ためにこれからできることを、1つだけ書いてください(行動でも意識でも)。", lines: 3 },
          ]}
          miniWorkLabel="✧ MINI WORK — 聖なる結界"
          miniWorkSteps={[
            "目を閉じ、アラムムル湖の静かな水面をイメージする",
            "その水が、あなたの全身を包む光の膜になるイメージで",
            "「私はこの光に守られています」と心の中で3回唱える",
            "その膜が今日一日続くことを意図して、ゆっくり目を開ける",
          ]}
          declaration={"私は聖なる光に守られています。\n必要なものだけを取り入れ、\nそうでないものは愛を込めて手放します。"}
        />

        {/* DAY 5 */}
        <DayPage
          day={5} phase="PHASE 2 · 保護 · アラムムル湖"
          title="影響を受けにくい状態をつくる"
          subtitle="他者のエネルギーと自分のエネルギーを識別する"
          intention="「これは私のエネルギーか?それとも誰かからもらったものか?」その違いに気づける日。"
          questions={[
            { q: "今感じているネガティブな感情や不安は、どこから来ているものでしょうか?自分の内側から?それとも外からの影響?", lines: 4 },
            { q: "もし「自分のものでない感情」があるとしたら、それを今ここで返してあげましょう。「これはあなたのもの、愛を込めてお返しします」と書いてみてください。", lines: 3 },
          ]}
          miniWorkLabel="✧ MINI WORK — エネルギーの識別"
          miniWorkSteps={[
            "手を胸の前に置き、今感じているものを感じる",
            "「これは私のもの?」と静かに問いかける",
            "自分のものでないと感じたら、息を吐きながら「返します」と意図する",
            "残ったものが「本当の自分のエネルギー」です",
          ]}
          declaration={"私は自分のエネルギーを識別できます。\n他者のものは愛を込めて手放します。\n私の内側はいつも、私だけのものです。"}
        />

        {/* DAY 6 */}
        <DayPage
          day={6} phase="PHASE 2 · 保護 · アラムムル湖"
          title="守られた安心感を定着させる"
          subtitle="保護のエネルギーを身体に記憶させる"
          intention="「守られている」という感覚は、信じることで強くなります。今日は、その安心感を身体の奥に刻み込む日。"
          questions={[
            { q: "過去に「守られた」「助けられた」と感じた瞬間を思い出してください。どんな出来事でしたか?", lines: 4 },
            { q: "「私はいつも守られている」という言葉を受け取るとき、身体のどこかで感じるものがありますか?気づいたことを書いてください。", lines: 3 },
          ]}
          miniWorkLabel="✧ MINI WORK — 安心の記憶"
          miniWorkSteps={[
            "Q1の記憶を思い浮かべ、そのときの安心感を身体で感じる",
            "胸や腹のあたりで感じるものに意識を向ける",
            "「この感覚が私のデフォルトです」と意図する",
            "その感覚のまま、3日間のアラムムルのワークに感謝する",
          ]}
          declaration={"私はいつも守られています。\n見えない力が私を支えています。\n安心がわたしの土台です。"}
        />

        {/* PHASE 3 */}
        <div className="wb-section-divider">✦ PHASE 3 — 軸 ✦</div>

        {/* DAY 7 */}
        <DayPage
          day={7} phase="PHASE 3 · 軸 · マチュピチュ"
          title="軸を立てる"
          subtitle="「本当の自分」の中心線に戻る"
          intention="天空の都市マチュピチュが持つ、揺るぎない「軸」のエネルギーを受け取ります。あなたの内側にも、同じ軸がすでに存在しています。"
          questions={[
            { q: "「本当の自分」とは、どんな人だと思いますか?肩書きや役割を取り除いたとき、あなたの核にあるものは?", lines: 4 },
            { q: "最近「自分らしくない」と感じた瞬間はありましたか?そのとき何が起きていましたか?", lines: 3 },
          ]}
          miniWorkLabel="✧ MINI WORK — 軸を立てる"
          miniWorkSteps={[
            "背筋を伸ばして座る(または立つ)",
            "頭のてっぺんから地球の中心へ、一本の光の柱が通るイメージを持つ",
            "「私はここにいる」と心の中で言いながら、足の裏の感覚を感じる",
            "その軸に乗って、今ここに存在していることを確認する",
          ]}
          declaration={"私の内側に、揺るぎない軸があります。\nどんなときも、ここに戻れます。\n私は私である。それで十分です。"}
        />

        {/* DAY 8 */}
        <DayPage
          day={8} phase="PHASE 3 · 軸 · マチュピチュ"
          title="ブレない自己軸を確認する"
          subtitle="揺れながらも戻れる場所を知っている感覚"
          intention="軸はブレないことではありません。ブレても、必ずここに戻れると知っていること。今日はその「帰り道」を刻みます。"
          questions={[
            { q: "あなたが「自分らしい」と感じるとき、どんな状態・環境・行動のときですか?", lines: 4 },
            { q: "軸がブレたと感じたとき、自分を取り戻すために「これをすれば戻れる」というものはありますか?あれば書いてみてください。", lines: 3 },
          ]}
          miniWorkLabel="✧ MINI WORK — 帰り道を刻む"
          miniWorkSteps={[
            "Q2に書いた「戻る方法」を一つ、今日実際に行ってみる",
            "その後で、昨日のミニワーク(軸の柱)を再度行う",
            "「これが私の中心」と確認する",
          ]}
          declaration={"揺れても大丈夫。私にはいつも戻れる場所がある。\nマチュピチュの大地のように、\n私の軸は揺るぎなく存在しています。"}
        />

        {/* PHASE 4 */}
        <div className="wb-section-divider">✦ PHASE 4 — 創造 ✦</div>

        {/* DAY 9 */}
        <DayPage
          day={9} phase="PHASE 4 · 創造 · マチュピチュ"
          title="願いと意図を解き放つ"
          subtitle="クリアな状態から、本当に望むものと繋がる"
          intention="浄化され、守られ、軸が立った今だからこそ。本当に望むものが、静かに浮かび上がってきます。今日はただ、それを受け取ってください。"
          questions={[
            { q: "今のあなたが「本当に望んでいること」を3つ書いてください。「叶うかどうか」は考えずに。", lines: 5 },
            { q: "その願いが叶った状態の自分は、どんな毎日を送っていますか?自由に描いてください。", lines: 4 },
          ]}
          miniWorkLabel="✧ MINI WORK — 意図の種を蒔く"
          miniWorkSteps={[
            "Q1の願いを一つ選び、目を閉じる",
            "すでに叶った状態にいる自分を、感情ごとを感じる(喜び、安心、感謝)",
            "その感情を胸の中心に集め、宇宙に「意図」として放つ",
            "「ありがとう」と言って手放す。執着しないことが大切です",
          ]}
          declaration={"私の願いは、すでに宇宙に届いています。\n私はそれを受け取る準備ができています。\n最善のタイミングで、最善の形で現れます。"}
          declarationLabel="FINAL DECLARATION"
          completeLabel="✦ ALL 10 DAYS COMPLETE ✦"
        />

        {/* DAY 10 */}
        <DayPage
          day={10} phase="PHASE 4 · 創造 · マチュピチュ"
          title="再構築の完成・これからへ"
          subtitle="10日間を統合し、新しい自分を日常に迎え入れる"
          intention="10日間、よく来てくれました。今日は終わりではなく、新しい自分との出会いの始まりです。"
          questions={[
            { q: "10日前の自分と今の自分を比べてみてください。何か変わったこと、気づいたことを自由に書いてください(大きくても小さくても)。", lines: 5 },
            { q: "この先の自分に向けて、「一番大切にしたいこと」を一言で書いてください。", lines: 2 },
            { q: "この10日間で出会えた「新しい自分」へ、自由にメッセージを書いてください。", lines: 5 },
          ]}
          miniWorkLabel="✧ FINAL WORK — 統合の儀式"
          miniWorkSteps={[
            "目を閉じ、3つの聖地(ウユニ塩湖・アラムムル・マチュピチュ)を順に思い浮かべる",
            "それぞれに「ありがとう」と心から伝える",
            "3つの光(白・深緑・金)が身体の中に集まり、ひとつの光になるイメージで",
            "その光を胸の中心に宿し、「この光とともに歩みます」と意図する",
            "ゆっくり目を開け、笑顔で深呼吸を一つ",
          ]}
          declaration={"私は浄化され、守られ、軸を持って、\n今ここから創造を始めます。\n三大聖地の光は、私の中で生き続けています。\nありがとう。いつも、ありがとう。"}
          declarationLabel="FINAL DECLARATION"
          completeLabel="✦ ALL 10 DAYS COMPLETE ✦"
        />

        {/* CLOSING */}
        <div className="wb-closing-page">
          <div className="wb-stars" id="stars2"></div>
          <p className="wb-closing-message">
            10日間、あなたは<br />
            誠実に自分と向き合いました。<br /><br />
            何かを感じた日も、<br />
            何も感じなかった日も、<br />
            すべてが等しく美しいプロセスです。<br /><br />
            南米の聖地たちは今も、<br />
            あなたの内側で光り続けています。<br /><br />
            これからも、どうぞ<br />
            自分を愛し続けてください。
          </p>
          <div style={{ width: "40px", height: "1px", background: "#c9a96e", margin: "0 auto 20px" }}></div>
          <p className="wb-closing-sig">穴口 恵子</p>
        </div>
      </div>
    </>
  );
}

interface DayPageProps {
  day: number;
  phase: string;
  title: string;
  subtitle: string;
  intention: string;
  questions: { q: string; lines: number }[];
  miniWorkLabel: string;
  miniWorkContent?: string;
  miniWorkSteps: string[];
  declaration: string;
  declarationLabel?: string;
  completeLabel?: string;
}

function DayPage({
  day, phase, title, subtitle, intention, questions,
  miniWorkLabel, miniWorkContent, miniWorkSteps,
  declaration, declarationLabel = "TODAY'S DECLARATION — 今日の宣言",
  completeLabel,
}: DayPageProps) {
  return (
    <div className="wb-day-page">
      <div className="wb-day-header">
        <div className="wb-day-circle">
          <div className="wb-day-circle-label">DAY</div>
          <div className="wb-day-circle-num">{day}</div>
        </div>
        <div>
          <h2 className="wb-day-title">{title}</h2>
          <p className="wb-day-subtitle">{subtitle}</p>
        </div>
      </div>

      <div className="wb-intention-box">
        <div className="wb-intention-label">TODAY'S INTENTION</div>
        <p className="wb-intention-text">{intention}</p>
      </div>

      {questions.map((item, i) => (
        <div className="wb-question-block" key={i}>
          <div className="wb-question-label">
            <span className="wb-q-num">Q{i + 1}</span>
            <span className="wb-q-text">{item.q}</span>
          </div>
          <div className="wb-write-lines">
            {Array.from({ length: item.lines }).map((_, j) => (
              <div className="wb-write-line" key={j}></div>
            ))}
          </div>
        </div>
      ))}

      <div className="wb-mini-work">
        <div className="wb-mini-work-label">{miniWorkLabel}</div>
        {miniWorkContent && <div className="wb-mini-work-content">{miniWorkContent}</div>}
        <ul className="wb-mini-work-steps">
          {miniWorkSteps.map((s, i) => <li key={i}>{s}</li>)}
        </ul>
      </div>

      <div className="wb-declaration">
        <div className="wb-declaration-label">{declarationLabel}</div>
        <div className="wb-declaration-text">
          {declaration.split("\n").map((line, i) => (
            <span key={i}>{line}{i < declaration.split("\n").length - 1 && <br />}</span>
          ))}
        </div>
      </div>

      <div className="wb-water-reminder">
        <span className="wb-water-icon">💧</span>
        <span className="wb-water-text">宣言の後は、水を一口飲んでください。エネルギーを身体に定着させます。</span>
      </div>

      <div className="wb-complete-row">
        <span className="wb-check-box"></span>
        <span className="wb-complete-label">{completeLabel ?? `DAY ${day} COMPLETE`}</span>
      </div>
    </div>
  );
}
